exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip.popover.hidden{display:none!important;visibility:hidden!important;opacity:0!important}.tooltip-inner .icon-button{color:#ddd;padding:4px!important;margin:0!important;width:28px!important}.tooltip-inner .icon-button:focus,.tooltip-inner .icon-button:hover{color:#fff}ul.submenu{list-style:none;margin:0;padding:0}ul.submenu li a{color:#0c0a1c;display:block;padding:5px 18px}ul.submenu li a:focus,ul.submenu li a:hover{color:#07070e;background:rgba(0,0,0,.04)}", ""]);

// exports
